import { useFirestoreAllArrayContains } from '../../firebase/useFirestore';
import { client } from '../../hooks/Client';
import PageHeader from '../../components/layout/PageHeader';
import { useState } from 'react';
import SelectableGrid from '../../components/common/SelectableGrid';
import { db } from '../../firebase/config';
import ProjectOutputProgress from '../../components/portfolio/ProjectOutputProgress';
import ProjectResearchProgress from '../../components/portfolio/ProjectResearchProgress';
import ProjectReportsProgress from '../../components/portfolio/ProjectReportsProgress';
import Table from '../../components/common/table/Table.jsx';
import TableCell from '../../components/common/table/TableCell.jsx';
import ReadOnlyGuard from '../../components/common/ReadOnlyGuard';

const Progress = () => {
    // State
    const [selectedStatus, setSelectedStatus] = useState('all')

     // Firestore
     const projects = useFirestoreAllArrayContains('CompagnyMeta', 'Parent', client)
     const selectedProjects = projects && projects.filter(project => selectedStatus === 'all' ? project : selectedStatus === 'active' ? project.Status === 'active' : project.Status === 'inactive')

     // Options
    const options = [
        { key: 'all', label: 'Alle' },
        { key: 'active', label: 'Actief' },
        { key: 'inactive', label: 'Inactief' },
    ];

     // Status handler
    const statusHandler = (e) => {
        const docid = e.target.getAttribute('data-docid')
        const value = e.target.options[e.target.selectedIndex].value
        db.collection('CompagnyMeta').doc(docid).update({
            Status: value
        })
    }

  return (
    <div className="main">
        <div className="main-container">
            <PageHeader 
                heading={'Voortgang'}
                description={`Hier vind je de voortgang van de projecten uit jouw portfolio.`}
                AI={false}
            />
            <SelectableGrid
                items={options}
                getId={(item) => item.key}
                getLabel={(item) => item.label}
                selectedId={selectedStatus}
                onClick={setSelectedStatus}
            />
            <ReadOnlyGuard edit="portfolio.edit">
            <Table
                columns={[
                    { key: 'name', label: 'NAAM' },
                    { key: 'status', label: 'STATUS', searchable: false },
                    { key: 'toc', label: 'TOC', searchable: false },
                    { key: 'outputs', label: 'OUTPUTS', searchable: false },
                    { key: 'research', label: 'ONDERZOEK', searchable: false },
                    { key: 'reports', label: 'RAPPORTAGES', searchable: false },
                ]}
                items={selectedProjects || []}
                emptyMessage="Geen projecten gevonden."
                searchPlaceholder="Zoeken op naam"
                searchAccessor={(project) => project?.CommunityName || ''}
                renderRow={(project) => (
                    <>
                        <TableCell>
                            <p>{project.CommunityName}</p>
                        </TableCell>
                        <TableCell>
                            <select name="" id="" data-docid={project.docid} value={project.Status} onChange={statusHandler}>
                                <option value="">-- Selecteer status --</option>
                                <option value="active">Actief</option>
                                <option value="inactive">Inactief</option>
                            </select>
                        </TableCell>
                        <TableCell />
                        <TableCell>
                            <ProjectOutputProgress projectId={project.CompagnyID} />
                        </TableCell>
                        <TableCell>
                            <ProjectResearchProgress projectId={project.CompagnyID} />
                        </TableCell>
                        <TableCell>
                            <ProjectReportsProgress projectId={project.CompagnyID} />
                        </TableCell>
                    </>
                )}
            />
            </ReadOnlyGuard>
        </div>

    </div>
  )
}

export default Progress
